
import { Vue, Options } from "vue-class-component";
import StorageService from "../services/StorageService";
import ApiService from "../services/ApiService";
import { wrapper } from "../utils/wrapper";
import { useStore } from "vuex";
import { INVALID_PASSWORD_REGEX } from "@/config";

@Options({
  props: {
    showModal: Boolean
  }
} as any)
export default class ChangePasswordModal extends Vue {
  private storageService = new StorageService();
  private apiService = new ApiService();
  globalStore = useStore();
  newPassword = "";
  confirmPassword = "";
  error = false;
  errorMessage =
    "Passwords must have at least 8 characters with at least one upper case, one lower case, one number and one non-alphanumeric character";
  mismatchError = false;
  mismatchMessage = "Password fields must be filled with the same characters";

  invalidPasswords() {
    if (!this.newPassword || !this.confirmPassword) {
      return true;
    }
    if (
      INVALID_PASSWORD_REGEX.test(this.newPassword) ||
      INVALID_PASSWORD_REGEX.test(this.confirmPassword)
    ) {
      this.error = true;
      return true;
    } else this.error = false;
    if (this.newPassword === this.confirmPassword) {
      this.mismatchError = false;
      return false;
    } else {
      this.mismatchError = true;
      return true;
    }
  }

  closeModal() {
    this.$emit("clicked", "accepted");
  }

  async resetPassword() {
    const user = this.storageService.getUser();
    const id = user.patientsId;
    const resetResponse = await wrapper(
      this.apiService.reset(id, this.newPassword)
    );
    if (resetResponse.error) {
      console.error(resetResponse.error);
      if (resetResponse.error.status === 400) {
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.PASSWORD.INVALID.TITLE"),
          text: this.$t("ALERTS.PASSWORD.INVALID.TEXT")
        });
      } else {
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.PASSWORD.FAILED.TITLE"),
          text: this.$t("ALERTS.PASSWORD.FAILED.TEXT")
        });
      }
    }
    if (resetResponse.data) {
      this.globalStore.commit("open", {
        type: "success",
        title: this.$t("ALERTS.PASSWORD.SUCCESS.TITLE"),
        text: this.$t("ALERTS.PASSWORD.SUCCESS.TEXT")
      });
    }
    this.closeModal();
  }
}
